import { c as _c } from "react/compiler-runtime";
import { NamespaceMapper, defaultBrandSettings, getBrandFromLocalStorage, getTFuncWithNamespace, getUseLocoTranslation } from '@systemeio/util';
import { TFunction, TOptions } from 'i18next';
import { FormatXMLElementFn, PrimitiveType } from 'intl-messageformat';
import { i18n, useTranslation } from 'next-i18next';
import { useCallback } from 'react';
import LocalizeNamespaces from 'shared/constants/localize-namespaces.mjs';
import { formUrl } from 'shared/utils/links/form-url';
import { useTranslation as useTranslationReact } from 'react-i18next';
export type LocalizeKeys = keyof typeof LocalizeNamespaces;
export type LocalizeValues = typeof LocalizeNamespaces[LocalizeKeys];
export type TLocoType = ReturnType<typeof getTFuncWithNamespace>;
const namespaceMapper: NamespaceMapper = (assetKey: string) => {
  if (assetKey === undefined) return undefined;
  const basePart = assetKey.split('.')[0];
  switch (basePart) {
    case 'global':
    case 'core':
      return [LocalizeNamespaces.global];
    case 'header':
      return [LocalizeNamespaces.header];
    case 'confirmation_modal':
      return [LocalizeNamespaces.confirmation];
    case 'currency':
      return [LocalizeNamespaces.currency];
    case 'locale':
      return [LocalizeNamespaces.locale];
    case 'dashboard':
      {
        const namespaceFromKey = assetKey.split('.')[1];
        return [LocalizeNamespaces[namespaceFromKey as LocalizeKeys], ...Object.values(LocalizeNamespaces)];
      }
    default:
      return undefined;
  }
};
const defaultNamespaces = [LocalizeNamespaces.global, LocalizeNamespaces.header, LocalizeNamespaces.notifications, LocalizeNamespaces.locale];
const globalVariables = {
  brandName: (getBrandFromLocalStorage() ?? defaultBrandSettings).name,
  mainWebsiteUrl: formUrl('', false),
  dashboardUrl: formUrl('')
};
export const tWithNamespace = (assetKey: string, options?: TOptions) => {
  if (!i18n?.t) return '';
  return getTFuncWithNamespace(i18n.t as unknown as TFunction, namespaceMapper)(assetKey, {
    ...globalVariables,
    ...options
  });
};
const useLocoTranslationHook = getUseLocoTranslation({
  useTranslation: useTranslation as unknown as typeof useTranslationReact,
  defaultNamespaces,
  namespaceMapper
});
export const useLocoTranslation: typeof useLocoTranslationHook = () => {
  const $ = _c(12);
  const t0 = useLocoTranslationHook();
  let rest;
  let tICUTemp;
  let tTemp;
  if ($[0] !== t0) {
    ({
      t: tTemp,
      tICU: tICUTemp,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = rest;
    $[2] = tICUTemp;
    $[3] = tTemp;
  } else {
    rest = $[1];
    tICUTemp = $[2];
    tTemp = $[3];
  }
  let t1;
  if ($[4] !== tTemp) {
    t1 = (assetKey, options) => tTemp(assetKey, {
      ...globalVariables,
      ...options
    });
    $[4] = tTemp;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t = t1;
  let t2;
  if ($[6] !== tICUTemp) {
    t2 = (assetKey_0, values, options_0) => tICUTemp(assetKey_0, values, {
      ...globalVariables,
      ...options_0
    });
    $[6] = tICUTemp;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const tICU = t2;
  let t3;
  if ($[8] !== rest || $[9] !== t || $[10] !== tICU) {
    t3 = {
      t,
      tICU,
      ...rest
    };
    $[8] = rest;
    $[9] = t;
    $[10] = tICU;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};